import { ModalLogin } from "components/login/modalLogin";
import * as message from "components/message/message";
import { S6RequestConfig } from "components/request/request";

export class S6Response {
    private promise: Promise<void | Response>;
    private responseCallback: (r: any) => void;
    private catchCallback: (ex) => void;
    private notFoundCalback: () => void;
    private options: S6RequestConfig;

    constructor(options: S6RequestConfig) {
        this.options = options;
        this.run();
    }

    private run() {
        fetch(this.options.url,
            {
                credentials: "include",
            },
        )
            .then((response) => {
                if (!response.ok) {
                    let error = Error(response.statusText);
                    error["status"] = response.status;
                    error["response"] = response;
                    throw error;
                }

                return response.json();
            }).then((res) => {
                this.responseCallback(res);
            }).catch((ex) => {
                if (ex.status === 404 && this.notFoundCalback != null) {
                    return this.notFoundCalback();
                }
                if (ex.status === 401 && this.options.reauthenticate != null) {
                    ModalLogin.open({
                        title: "hello",
                        url: "/login",
                        callback: () => this.run(),
                    });
                } else if (ex.status === 403) {
                    message.show({
                        level: "error",
                        key: "error.not_authorized",
                    });
                } else if (this.catchCallback == null) {
                    message.show({
                        level: "error",
                        key: "error in request for {0}",
                    });
                    console.error("error in request for {0}", this.options.url, ex);
                } else {
                    this.catchCallback(ex);
                }
            });
    }

    public res(response) {
        this.responseCallback = response;
        return this;
    }

    public notFound(callback) {
        this.notFoundCalback = callback;
    }
    public catch(callback) {
        this.catchCallback = callback;
    }
}
